"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowButtonSet_1 = require("../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../../shared/components/containers/CardEditorContainer");
var BonusTemplatePlayerTagEditor = /** @class */ (function (_super) {
    __extends(BonusTemplatePlayerTagEditor, _super);
    function BonusTemplatePlayerTagEditor(props) {
        return _super.call(this, props) || this;
    }
    BonusTemplatePlayerTagEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.setState({
            usr_player_tag_id: 0,
            usr_player_tag_title: ""
        }, function () {
            _this.props.state.setExtBreadCrumbPath(["Метки игроков шаблона бонуса", "Добавление метки игрока"]);
        });
        this.doReSetRules();
    };
    BonusTemplatePlayerTagEditor.prototype.doReSetRules = function () {
        this.setState({
            usr_player_tag_rules: { isError: false }
        });
    };
    BonusTemplatePlayerTagEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.usr_player_tag_id <= 0) || (this.state.usr_player_tag_title.length === 0)) {
            this.setState({ usr_player_tag_rules: { isError: true, errorMessage: "Метка не выбрана!" } });
            return false;
        }
        return true;
    };
    BonusTemplatePlayerTagEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                usr_player_tag_id: this.state.usr_player_tag_id,
                bonus_template_id: this.props.rootRecord.key
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Метка игроков бонуса добавлена!");
            });
        }
    };
    BonusTemplatePlayerTagEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BonusTemplatePlayerTagEditor.prototype.getFormTitle = function () {
        return "Новая метка игрока бонуса";
    };
    BonusTemplatePlayerTagEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 250 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Метка игрока", placeholder: "Выберите метку игрока" }, value: {
                    key: this.state.usr_player_tag_id,
                    value: this.state.usr_player_tag_title
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        usr_player_tag_id: newVal.key,
                        usr_player_tag_title: newVal.value,
                        usr_player_tag_rules: { isError: false }
                    });
                }, items: this.props.availPlayerTags, required: true, rules: this.state.usr_player_tag_rules }),
            React.createElement(CardRowButtonSet_1.default, { editMode: false, title: { btnNew: "Добавить", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this) })));
    };
    return BonusTemplatePlayerTagEditor;
}(React.Component));
exports.default = BonusTemplatePlayerTagEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_bonus_templates/ui/component/player_tags/BonusTemplatePlayerTagEditor.tsx
// module id = 1904
// module chunks = 0